var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractEditable from './abstract';
var CheckboxEditable = /** @class */ (function (_super) {
    __extends(CheckboxEditable, _super);
    function CheckboxEditable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxEditable.prototype.render = function () {
        var _this = this;
        var group = this.getElement().querySelector('.input__group.-checkbox');
        Object.keys(this._args.options).forEach(function (k) {
            var option = _this._args.options[k];
            group.insertAdjacentHTML('beforeEnd', _this._template.form.checkbox('option[]', option.value, option.text).outerHTML);
        });
    };
    CheckboxEditable.prototype.valueToInput = function (values) {
        var _this = this;
        if (Array.isArray(values)) {
            values.forEach(function (value) {
                var input = _this._element.querySelector("input[value=\"" + value + "\"]");
                if (input) {
                    input.checked = true;
                }
            });
        }
    };
    CheckboxEditable.prototype.getValue = function () {
        var array = [];
        this.getElement().querySelectorAll('form input[type=checkbox]:checked').forEach(function (c) { return array.push(c.value); });
        return array;
    };
    CheckboxEditable.prototype.getTemplate = function () {
        return "<div class=\"input__group -checkbox\"></div>";
    };
    CheckboxEditable.prototype._setDefaults = function () {
        this._defaults.options = [];
        this._defaults.type = 'checkbox';
    };
    return CheckboxEditable;
}(AbstractEditable));
export default CheckboxEditable;
